/* "Seawater" by tPenguinLTG
 * https://www.deviantart.com/tpenguinltg/art/FxDev-701274128
 */

export default {
  name: 'fxDev',
  anchor: 'rgb(47, 138, 202)',
  anchorVisited: 'rgb(47, 138, 202)',
  borderDark: 'rgb(27, 33, 39)',
  borderDarkest: 'rgb(7, 9, 10)',
  borderLight: 'rgb(69, 82, 94)',
  borderLightest: 'rgb(107, 113, 122)',
  canvas: 'rgb(23, 27, 31)',
  canvasText: 'rgb(245, 247, 250)',
  canvasTextDisabled: 'rgb(27, 33, 39)',
  canvasTextDisabledShadow: 'rgb(107, 113, 122)',
  canvasTextInvert: 'rgb(255, 255, 255)',
  checkmark: 'rgb(245, 247, 250)',
  checkmarkDisabled: 'rgb(133, 136, 140)',
  flatDark: 'rgb(27, 33, 39)',
  flatLight: 'rgb(57, 66, 77)',
  focusSecondary: 'rgb(107, 113, 122)',
  headerBackground: 'rgb(26, 70, 102)',
  headerNotActiveBackground: 'rgb(28, 33, 38)',
  headerNotActiveText: 'rgb(245, 247, 250)',
  headerText: 'rgb(245, 247, 250)',
  hoverBackground: 'rgb(7, 77, 117)',
  material: 'rgb(57, 66, 77)',
  materialDark: 'rgb(28, 33, 38)',
  materialText: 'rgb(255, 255, 255)',
  materialTextDisabled: 'rgb(27, 33, 39)',
  materialTextDisabledShadow: 'rgb(107, 113, 122)',
  materialTextInvert: 'rgb(255, 255, 255)',
  progress: 'rgb(7, 77, 117)',
  tooltip: 'rgb(243, 242, 219)',
};
